import { createClient, safeRequest } from '../clientConfiguration';

export const bulkImportApiClient = createClient({
  baseURL: '/rest-api/bulk-upload/v1',
});

export const getSmartTemplate = async (entity: string, corpAccount: string) => {
  try {
    return await bulkImportApiClient.get(
      `/corp-account/${corpAccount}/templates/${entity}`,
      { responseType: 'blob' },
    );
  } catch (error) {
    return error;
  }
};

export const getBulkImportHistory = (corpAccount: string) => {
  return safeRequest(() =>
    bulkImportApiClient.get(`/corp-account/${corpAccount}/jobs`),
  );
};

export const getLocksForAllEntities = (corpAccount: string) => {
  return safeRequest(() =>
    bulkImportApiClient.get(`/corp-account/${corpAccount}/jobs/locks/entities`),
  );
};

export const uploadBulkImport = ({
  file,
  corpAcctNbr,
  bulkEdit,
}: {
  file: FormData;
  corpAcctNbr: string;
  bulkEdit: boolean;
}) => {
  return bulkImportApiClient.post(
    `/corp-account/${corpAcctNbr}/jobs${bulkEdit ? '?entity=USER_UPDATE' : ''}`,
    file,
    {
      headers: {
        accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    },
  );
};

export const getBulkImportJobError = (corpAccount: string, jobId: string) => {
  return bulkImportApiClient.get(
    `/corp-account/${corpAccount}/jobs/${jobId}/file?payloadType=DATA_WITH_ERRORS`,
    {
      headers: {
        accept: 'application/octet-stream',
      },
      responseType: 'blob',
    },
  );
};
